import { useEffect, useState } from 'react';
import { Card, Typography, Table, Tag, Space, Button } from 'antd';

interface HealthData { status: string; conversations: number; time: string }

const HealthPage = () => {
  const [data, setData] = useState<HealthData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const mock = (import.meta as any).env?.VITE_MOCK_MODE === 'true' || (window as any).__MOCK_MODE__ === true;

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch('/api/health');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const json = await res.json();
      setData(json);
    } catch (e: any) {
      setError(e.message || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-screen bg-[#121826] p-8">
      <Card title="Application Health" className="!max-w-[720px] !mx-auto !bg-[#1F2937] !border !border-solid !border-[#414756]" classNames={{ header: '!text-white', body: '!text-white' }}>
        <Typography.Paragraph className="!text-[#9ca3af]">
          Runtime diagnostic snapshot. Mock Mode: {mock ? <Tag color="gold">ENABLED</Tag> : <Tag color="green">OFF</Tag>}
        </Typography.Paragraph>
        <Space className="!mb-3">
          <Button size="small" onClick={load} loading={loading}>Refresh</Button>
        </Space>
        {error && <Typography.Text type="danger">{error}</Typography.Text>}
        {data && (
          <Table
            size="small"
            pagination={false}
            dataSource={[
              { key:'status', label:'Status', value:data.status },
              { key:'convos', label:'Conversations (in-memory)', value:data.conversations },
              { key:'time', label:'Server Time', value:new Date(data.time).toLocaleString() },
            ]}
            columns={[
              { title:'Metric', dataIndex:'label', key:'label' },
              { title:'Value', dataIndex:'value', key:'value' },
            ]}
            rowKey="key"
            className="!bg-[#1F2937]"
          />
        )}
      </Card>
    </div>
  );
};
export default HealthPage;
